Alpine.data('developerSelect2', () => ({
    selectDropdown: null,
    developers: [],
    init() {
        var _self = this;
        this.$nextTick();
        this.selectDropdown = $(this.$refs.developerDropdown).select2({
            // ajax: {
            //     dataType: 'json',
            //     url: '/api/local/developers',
            // },
            selectionCssClass: "text-sm my-dropdown-10-oct overflow-x-hidden h-10 transition-all duration-300 ease-in-out scrollA",

            // selectionCssClass: "text-sm font-medium black-border font-sans pt-1 pl-1 transition-all delay-150 duration-100 overflow-hidden leading-4 h-10 border-red-500 mt-2 md:mt-0 mb-6 md:mb-0 bg-white",
            required: true,
            // width: "100%",
            multiple: true,
            maximumSelectionLength: 4,
            closeOnSelect: true,
            scrollAfterSelect: false,
            selectOnClose: false,
            placeholder: {
                id: '-1', // the value of the option
                text: 'Developer'
            },
            language: {
                noResults: function () {
                    return null;
                },
                searching: function () {
                    return null;
                },
                maximumSelected: function (e) {
                    var t = "You can enter up to " + e.maximum + " developers only";
                    return t;
                }
            },
            escapeMarkup: function (markup) {
                return markup;
            },
        });
        _self.$nextTick(() => {
            var data = _self.getQueryStrings();
            const selectedDevelopers = Object.keys(data)
                .filter(key => key.startsWith("selectedDevelopers"))
                .map(key => data[key]);
            this.selectDropdown.val(selectedDevelopers).trigger('change')
        })

        this.selectDropdown.off('select2:select').on('select2:select', function (e) {

            let selectionDeveloperSpan = e.target.parentElement;
            selectionDeveloperSpan.style.height = selectionDeveloperSpan.scrollHeight + 'px'
            const event = new CustomEvent('developer-selection', {
                detail: {
                    id: e.params.data.id,
                    type: 'add'
                }
            })
            window.dispatchEvent(event)
        }).on('select2:unselecting', function (e) {
            let selectionDeveloperSpan = e.target.parentElement;

            // temporarily lock height to avoid jump
            selectionDeveloperSpan.style.height = selectionDeveloperSpan.scrollHeight + 'px';

            const event = new CustomEvent('developer-selection', {
                detail: {
                    id: e.params.args.data.id,
                    type: 'remove'
                }
            });
            window.dispatchEvent(event);
        })
            .on('select2:opening', () => {
                $('.my-dropdown-10-oct')
                    .removeClass('h-10')
                    .parent()
                    .addClass('h-full overflow-y-hidden');
            })
            .on('select2:closing', (event) => {
                const $dropdown = $('.my-dropdown-10-oct');

                $dropdown.addClass('h-10 overflow-y-scroll scrollA');
                $dropdown.parent().removeClass('h-full overflow-y-hidden');

                // ✅ Reset manually set height
                setTimeout(() => {
                    $dropdown[0].style.height = ''; // clears inline height
                    const results = $dropdown[0];
                    if (results) results.scrollTop = 0;
                    let selectionDeveloperSpan = event.target.parentElement;

                    // temporarily lock height to avoid jump
                    selectionDeveloperSpan.style.height = '40px';
      }, 0);
            });

    },
    resetField() {
        this.selectDropdown.val([]).change();
    },
    getQueryStrings(key = null) {
        const query = window.location.search;
        const params = new URLSearchParams(query);
        if (key) {
            return params.getAll(key); // when get only
        }
        return Object.fromEntries(params.entries()); // all parameters
    },
}));
